import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useDebounce } from 'use-debounce'

import Input from '../input'
import Icon from '../icon'
import SearchIcon from '../icon/search.svg'
import classNames from 'classnames'

const delay = 900

const Search = ({
  customProps = {},
  onSearch = () => { },
  onEditing = () => { },
  isEditing
}) => {
  const [searchState, setSearchState] = useState('')
  const [searchDebounce] = useDebounce(searchState, delay)

  useEffect(() => {
    onSearch(searchDebounce)
  }, [searchDebounce])

  const _handleSearch = ({ target: { value } }) => {
    setSearchState(value)
  }

  const _handleClickInput = (ev) => {
    onEditing(true)
  }

  const _handleBlurInput = () => {
    onEditing(false)
  }

  return (
    <Input.Search
      icon={<Icon size={24} svg={SearchIcon} />}
      placeholder="Buscar"
      borderActiveColor="light-green"
      borderColor
      solid
      solidColor="light-gray"
      className={classNames([
        'w-full',
        // 'mb-10',
        // 'mt-6',
        isEditing ? 'w-full' : 'w-40 md:w-40',
        'md:mt-0'
      ])}
      value={searchState}
      onBlur={_handleBlurInput}
      onClick={_handleClickInput}
      onChange={_handleSearch}
      {...customProps}
    />
  )
}

Search.propTypes = {
  customProps: PropTypes.object,
  onSearch: PropTypes.func,
  onEditing: PropTypes.func,
  isEditing: PropTypes.bool
}

export default React.memo(Search)
